import { ThunkDispatch } from "@reduxjs/toolkit";

import { Deal } from "@/custom-types/Deals";
import {
  setUserMenuPreference,
  UserPreferenceChangeAction,
} from "@/redux/action-creators/user";
import { AppState } from "@/redux/store";

export const dealCardUpdateMedRec = async (
  deal: Deal,
  dispatch: ThunkDispatch<AppState, unknown, UserPreferenceChangeAction>,
): Promise<void> => {
  // if the deal is not medical only we want to direct the user to the rec menu
  const medRecCookieValue =
    deal.isMedical && !deal.isRecreational ? "Med" : "Rec";
  await dispatch(setUserMenuPreference(medRecCookieValue));
  return;
};
